// extracted by mini-css-extract-plugin
export default {"body":"Banner_body__AqaN3","content":"Banner_content__AO5K-","button":"Banner_button__D2ypd"};